import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const Footer = observer(class Footer extends React.Component {
  // changeLocale(locale) {
  //   if(locale) {
  //     this.props.store.SessionStore.updateLocale(locale);
  //   }
  // }

  docsLink() {
    const { userData } = this.props.store.SessionStore;

    let href = null;

    if(userData && userData.role) {
      switch (userData.role.toLowerCase()) {
        case 'learner':
          href = 'http://docs.smarterproctoring.com/support/solutions/27000014320';
          break;

        case 'instructor':
          href = 'http://docs.smarterproctoring.com/support/solutions/27000033928';
          break;

        case 'administrator':
          href = 'http://docs.smarterproctoring.com/support/solutions/27000033927';
          break;

        default:
          href = 'https://docs.smarterproctoring.com';
      }
    }

    return href;
  }

  render() {
    // Hund system status (check on a 100ms interval if anchor is there)
    // const statusElDelay = setInterval(function(){
    //   if(document.querySelector('#status') && window.Status && !document.querySelector('.status-widget__led')) {
    //     new window.Status.Widget({
    //       hostname: 'status.smarterproctoring.com',
    //       selector: '#status',
    //       css: false,
    //       display: {
    //         hideOnError: true,
    //         ledOnly: true,
    //         panePosition: 'top-left'
    //       }
    //     });
    //
    //     clearInterval(statusElDelay);
    //   }
    // }, 100);

    return (
      <footer className="site-foot">
        <div className="site-foot__copy wrap">
          <span>
            © {new Date().getFullYear()} SmarterServices, LLC
          </span>
        </div>
      </footer>
    );
  }
})

export default translate('Footer')(Footer);



// WEBPACK FOOTER //
// ./src/app/components/Common/Footer.js